import React from 'react'

import i18n from 'modules/core/lib/i18n'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import { DataCollectionCategories } from 'modules/processes/domain'
import { TaskTypes } from 'modules/processes/hooks/types'

import TaskCard from 'modules/processes/components/ItemWizard/components/ItemCard'

interface Props {
  onSelect: (taskType: TaskTypes) => void
}

const Selector = ({ onSelect }: Props) => {
  const { itemType } = useItemProvider()

  return (
    <TaskCard
      title={i18n.t('processes.process_settings.wizard.tasks.types.request_id.title')}
      description={i18n.t('processes.process_settings.wizard.tasks.types.request_id.description')}
      onSelect={() => {
        onSelect(DataCollectionCategories.identificationNumber)
      }}
      itemType={DataCollectionCategories.identificationNumber}
      value={itemType}
    />
  )
}

export default Selector
